import { HpChildComponentProps } from 'components/shared/componentWithModal/componentWithModal';
import { PageNavigation } from 'components/layout/navigation/pageNavigation';
import { PATH } from 'interfaces/pathTypes';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { AccountSettings } from './accountSettings';
import { AutoRenewalSettings } from './autoRenewalSettings';
import { DocumentPrintSettings } from './documentPrintSettings';

import './settings.scss';
import { useAppSelector } from 'store/hooks';
import { Title } from 'components/layout/header/title';
import { POLICY_LIFECYCLE_STATUS } from 'interfaces/customerDataTypes';

export const Settings = ({ selectedPolicy }: HpChildComponentProps): JSX.Element => {
  const isAgent = useAppSelector((state) => state.authentication.isAgent);
  const { atlasLifecycleStatus } = selectedPolicy;
  const location = useLocation();

  useEffect(() => {
    const scroll = (id: string) => {
      const section = document.querySelector(`#${id}`);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    if (location.hash) {
      // Remove the '#' character from the hash
      const hashId = location.hash.substring(1);
      scroll(hashId);
    }
  }, [location.hash]);
  return (
    <>
      <Title title="SETTINGS" icon="cog-circle" id="settings" />
      <div className="settings-container">
        {selectedPolicy && (
          <>
            <AccountSettings selectedPolicy={selectedPolicy} />
            {atlasLifecycleStatus !== POLICY_LIFECYCLE_STATUS.POLICY_LIVE_EXPIRING && (
              <AutoRenewalSettings selectedPolicy={selectedPolicy} />
            )}
            {isAgent && <DocumentPrintSettings selectedPolicy={selectedPolicy} />}
          </>
        )}
      </div>
      <PageNavigation page={PATH.SETTINGS} />
    </>
  );
};
